import React, { Component } from 'react'
import { Container, Toolbar, SearchField, Button, Label } from '@sencha/ext-modern'
import Message from 'tyan/components/Message'
import SearchBar from './SearchBar'
import ListItem from './ListItem'
import { WX } from 'tyan/public'

Ext.require([
    'Ext.dataview.listswiper.ListSwiper',
    'Ext.MessageBox'
])
const style = {
    outer: {
        backgroundColor: "#f5f5f5",
        paddingTop: "10px",
        paddingBottom: "10px"
    }
}
class SpotCheckTask extends Component {
    state = {
        query: this.props.match.params.query || '',
        queryText: '',
        loading: false,
        errorMessage: null,
        spotCheckList: null,
        pageCount: 10,
        page: 1,
        totalCount: 0
    }

    componentDidMount() {
        const { pageCount } = this.state
        this.GetSpotCheckList(pageCount)
    }

    handleScanQRCode = () => {
        WX.scanQRCode({
            onScaned: ({ code }) => {
                this.setState({ query: code })
                this.handleSearch()
            }
        })
    }

    GetSpotCheckList = (row) => {
        const { query } = this.state
        if (!query) {
            this.setState({ spotCheckList: [], totalCount: 0 })
        } else {
            Tyan.doPostEvent('GetSpotCheckList', {
                data: { row, query, },
                onRequest: () => {
                    this.setState({ loading: true })
                },
                onEnd: ({ errorMessage, query, queryText, spotCheckList, totalCount }) => {
                    if (errorMessage) {
                        this.setState({ errorMessage })
                        return
                    }
                    this.setState({ loading: false, query, queryText, spotCheckList, totalCount })
                }
            })
        }
    }

    handleLoadMore = () => {
        let { page, pageCount } = this.state
        page += 1
        this.GetSpotCheckList(pageCount * page)
        this.setState({ page })
    }

    handleChange = (field, value) => {
        this.setState({ query: value })
    }

    handleSearch = () => {
        const { pageCount } = this.state
        this.GetSpotCheckList(pageCount)
    }

    handleAdd = ({ showDetail }) => {
        location.hash = `/QYWX/SpotPlanInfo/0`
    }

    handleChildTap = (id) => {
        location.hash = `/QYWX/SpotPlanExecute/${id}`
    }

    render() {
        const { errorMessage, spotCheckList, query, queryText, totalCount } = this.state
        if (errorMessage) {
            return <Message text="数据加载失败" subText={errorMessage} />
        } else if (!spotCheckList) {
            return <Message text="数据加载中..." />
        }

        return (
            <Container layout={{ type: "vbox" }} style={style.outer} scrollable >
                {/* {<SearchBar handleChange={this.handleChange} handleSearch={this.handleSearch} query={query} handleAdd={this.handleAdd} placeholder={"设备编号"} />} */}
                <Toolbar shadow={false} docked="top" padding="0" margin="0">
                    <SearchField ui="faded" placeholder="扫一扫" margin="0 20 0 20" value={queryText} readOnly={true} /* onChange={this.handleChange} */ />
                    <Button align="right" ui="action" iconCls={"x-fa fa-qrcode"} handler={this.handleScanQRCode} />
                </Toolbar>
                <ListItem dataList={spotCheckList} totalCount={totalCount} handleLoadMore={this.handleLoadMore} handleChildTap={this.handleChildTap} />
            </Container>
        )
    }
}
export default SpotCheckTask